// 무료 이용권 신청 이름
// 최소 2자 이상, 최대 49자 이하
export const validationName = (input) => {
    const regex = /^[A-Za-z가-힣]{2,49}$/;
    return regex.test(input.trim());
}

// 무료 이용권 신청 생년월일
// 숫자 8자리 (특수기호 포함하지 않음)
export const validateBirthdate = (input) => {
    const regex = /^\d{8}$/;
    return regex.test(input);
}

// 무료 이용권 신청 전화번호
// 숫자 11자리 (특수기호 포함하지 않음)
export const validatePhoneNumber = (input) => {
    const regex = /^010\d{8}$/;
    return regex.test(input);
}

// 무료 이용권 신청 회사명/단체명
// 최소 1글자 이상의 영문 혹은 한글, 최대 200글자 미만
export const validateCompany = (input) => {
    const regex = /^[A-Za-z가-힣]{1,199}$/;
    return regex.test(input);
}

// XSS protect
export const sanitizeInput = (str) => {
    return str
        .replace(/</g, '')
        .replace(/>/g, '')
        .replace(/javascript:/gi, '')
        .replace(/src=/gi, '')
        .replace(/style=/gi, '')
        .replace(/on\w+=/gi, '')
        .replace(/on\w+\s*\(/gi, '')
}